import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/supply-chains/item-fusions/${id}`)
          .then(res => {
            resolve(res.data.data.item_fusion)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    create({commit}, itemFusion) {
      return new Promise((resolve, reject) => {
        axios
          .post('/supply-chains/item-fusions', itemFusion)
          .then(res => {
            resolve(res.data.data.item_fusion)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, itemFusion) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/item-fusions/${itemFusion.id}`, itemFusion)
          .then(res => {
            resolve(res.data.data.item_fusion)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    check({commit}, fusionId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/item-fusions/${fusionId}/check`)
          .then(res => {
            resolve(res.data.data.item_fusion)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    makeFuse({commit}, fusionId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/item-fusions/${fusionId}/make-fuse`)
          .then(res => {
            resolve(res.data.data.item_fusion)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getPrintData({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/supply-chains/item-fusions/${id}/print-data`)
          .then(res => {
            resolve(res.data.data.items)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
